import { render, staticRenderFns } from "./AQuotation.vue?vue&type=template&id=53fbef6c&scoped=true"
import script from "./AQuotation.vue?vue&type=script&lang=js"
export * from "./AQuotation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53fbef6c",
  null
  
)

export default component.exports